import {CriterionRoute} from "@/router/Evaluation/CriterionRoute";

export const EvaluationPerformanceFile = {
    path: '/evaluation_performance_files',
    name: 'evaluation_performance_files',
    component: () => import('@/views/Evaluation/File/EvaluationPerformanceFilePage.vue'),
    children: [
        {
            path: '/evaluation_performance_files/add',
            name: 'evaluation_performance_files.add',
            component: () => import('@/views/Evaluation/File/Form/EvaluationFileForm.vue'),
            props: {
                addAction: true,
                type: 'EVALUATION_PERFORMANCE',
            },
            children: [
                ...CriterionRoute('evaluation_performance_files.add',
                    'EVALUATION_PERFORMANCE_CRITERION_CATEGORY',
                    'EVALUATION_PERFORMANCE')
            ]
        },
        {
            path: '/evaluation_performance_files/edit/:id',
            name: 'evaluation_performance_files.edit',
            component: () => import('@/views/Evaluation/File/Form/EvaluationFileForm.vue'),
            props: {
                updateAction: true,
                type: 'EVALUATION_PERFORMANCE',
            },
            children: [
                ...CriterionRoute('evaluation_performance_files.edit',
                    'EVALUATION_PERFORMANCE_CRITERION_CATEGORY',
                    'EVALUATION_PERFORMANCE')
            ]
        },
        {
            path: '/evaluation_performance_files/duplicate/:id',
            name: 'evaluation_performance_files.duplicate',
            component: () => import('@/views/Evaluation/File/Form/EvaluationFileForm.vue'),
            props: {
                duplicateAction: true,
                type: 'EVALUATION_PERFORMANCE',
            },
            children: [
                ...CriterionRoute('evaluation_performance_files.duplicate',
                    'EVALUATION_PERFORMANCE_CRITERION_CATEGORY',
                    'EVALUATION_PERFORMANCE')
            ]
        },
        {
            path: '/evaluation_performance_files/bulk_update',
            name: 'evaluation_performance_files.bulk_update',
            component: () => import('@/views/Evaluation/File/Form/BulkUpdateForm.vue'),
            props: {
                duplicateAction: true,
                type: 'EVALUATION_PERFORMANCE',
            },
            children: [
                ...CriterionRoute('evaluation_performance_files.bulk_update',
                    'EVALUATION_PERFORMANCE_CRITERION_CATEGORY',
                    'EVALUATION_PERFORMANCE')
            ]
        },
        {
            path: '/evaluation_performance_files/delete/:id',
            name: 'evaluation_performance_files.delete',
            component: () => import('@/views/Evaluation/File/Form/EvaluationFileForm.vue'),
            props: {
                deleteAction: true,
                type: 'EVALUATION_PERFORMANCE',
            }
        },
        {
            path: '/evaluation_performance_files/view/:id',
            name: 'evaluation_performance_files.view',
            component: () => import('@/views/Evaluation/File/Form/EvaluationFileForm.vue'),
            props: {
                viewAction: true,
                type: 'EVALUATION_PERFORMANCE',
            }
        },
        {
            path: '/evaluation_performance_files/archive/:id',
            name: 'evaluation_performance_files.archive',
            component: () => import('@/views/Evaluation/File/Form/EvaluationFileForm.vue'),
            props: {
                archiveAction: true,
                type: 'EVALUATION_PERFORMANCE',
            }
        },
        {
            path: '/evaluation_performance_files/unarchive/:id',
            name: 'evaluation_performance_files.unarchive',
            component: () => import('@/views/Evaluation/File/Form/EvaluationFileForm.vue'),
            props: {
                unarchiveAction: true,
                type: 'EVALUATION_PERFORMANCE',
            }
        },
    ]
}